'use client';
import { useTranslations } from 'next-intl';
import { useLocale } from 'next-intl';

// import sanitizeHtml from 'sanitize-html';

import AssemblyGuideBanner from './AssemblyGuideBanner/';
import ArticleItem from '@/ui/components/ArticleItem';
import { descriptionCute } from '@/utils/helpers';
import { urlBuilder } from '@/utils/urlBuilder';
import { addLocalePath } from '@/utils/urlBuilder/utils';

export default function ContentBlockTypes({ item }) {
  const locale = useLocale();
  const translate = useTranslations();

  if (!item?.title) {
    return null;
  }

  // if (
  //   item.type === 'helps' &&
  //   item.content.includes('https://www.youtube.com/')
  // ) {
  //   const sanitizeOptions = {
  //     allowedTags: 'no-html',
  //     allowedAttributes: 'no-html',
  //   };

  //   const removeHtml = sanitizeHtml(item?.content, sanitizeOptions);

  //   return (
  //     <ArticleItem
  //       key={item.id}
  //       href={`/article/${item?.slug}`}
  //       imgSrc={item.media.image.thumbnail}
  //       imgAlt={item.title}
  //       title={removeHtml}
  //       description={descriptionCute(item.content)}
  //       buttonLabel={translate('articleList-button-video')}
  //       buttonIcon="file-video"
  //       type="video"
  //       videoLink={item.content}
  //     />
  //   );
  // }

  if (!item?.type) {
    if (
      item?.parent === 273 ||
      item?.parent === 274 ||
      item?.parent === 275 ||
      item?.parent === 276 ||
      item?.parent === 277 ||
      item?.parent === 278 ||
      item?.parent === 279 ||
      item?.parent === 272
    ) {
      return <AssemblyGuideBanner item={item} />;
    }

    return (
      <>
        <ArticleItem
          key={item.id}
          href={addLocalePath(locale, `category/${item?.slug}`)}
          imgSrc={item.media.image.thumbnail}
          imgAlt={item.title}
          title={item.title}
          description={descriptionCute(item.content)}
          buttonLabel={translate('articleList-button-category')}
          buttonIcon="file-lines"
        />
      </>
    );
  }

  if (item.type === 'guides') {
    return (
      <ArticleItem
        key={item.id}
        href={urlBuilder({ item, locale })}
        imgSrc={item.media.image.thumbnail}
        imgAlt={item.title}
        title={item.title}
        description={descriptionCute(item.content)}
        buttonLabel={translate('articleList-button-guide')}
        buttonIcon="file-lines"
      />
    );
  }

  return (
    <ArticleItem
      key={item.id}
      href={urlBuilder({ item, locale })}
      imgSrc={item.media.image.thumbnail}
      imgAlt={item.title}
      title={item.title}
      description={descriptionCute(item.content)}
      buttonLabel={translate('articleList-button-article')}
      buttonIcon="file-lines"
    />
  );
}
